import { Chapter } from 'common/api/models/Chapter';
import { Product } from 'common/api/models/Product';
import { Tag } from 'common/api/models/Tag';
import { VftiRegistrant } from 'common/api/models/VftiRegistrant';
import { SummitRegistrant } from 'common/api/models/SummitRegistrant';
import { Member } from 'common/api/models/Member';

export class Entities {
  member: { [id: string]: Member } = {};
  chapter: { [id: string]: Chapter } = {};
  product: { [id: string]: Product } = {};
  tag: { [id: string]: Tag } = {};
  vftiregistrant: { [id: string]: VftiRegistrant } = {};
  summitRegistrant: { [id: string]: SummitRegistrant } = {};
}



// WEBPACK FOOTER //
// ./src/common/entity/Entities.ts